<template>
  <div id="container">
    <div
      id="header"
      class="border-b p-4"
      :class="mode === 'dark' ? 'border-dark-50' : ''"
    >
      <div class="flex items-center justify-between gap-2">
        <div class="ml-1 flex items-center gap-2" id="colorPans">
          <span class="text-[15px] font-medium">Colors (top k):</span>
          <div
            id="colorPan1"
            class="w-5 h-5 border-2 rounded-md cursor-pointer"
            :class="mode === 'dark' ? 'border-dark-50' : 'border-black-100'"
            style="background-color: #7ff581"
          >
            <input
              type="color"
              id="favcolor1"
              class="favcolor"
              name="favcolor"
              value="#7FF581"
            />
          </div>
          <input
            value="10"
            type="number"
            id="color1"
            class="colorThreshold w-[60px] border rounded-md text-xs outline-none font-medium appearance-none h-7 px-1.5"
            :class="mode === 'dark' ? 'bg-dark-70 border-dark-50' : ''"
          />
          <div
            id="colorPan2"
            class="w-5 h-5 border-2 rounded-md cursor-pointer"
            :class="mode === 'dark' ? 'border-dark-50' : 'border-black-100'"
            style="background-color: #fcfab6"
          >
            <input
              type="color"
              id="favcolor2"
              class="favcolor"
              name="favcolor"
              value="#FCFAB6"
            />
          </div>
          <input
            value="100"
            type="number"
            id="color2"
            class="colorThreshold w-[60px] border rounded-md text-xs outline-none font-medium appearance-none h-7 px-1.5"
            :class="mode === 'dark' ? 'bg-dark-70 border-dark-50' : ''"
          />
          <div
            id="colorPan3"
            class="w-5 h-5 border-2 rounded-md cursor-pointer"
            :class="mode === 'dark' ? 'border-dark-50' : 'border-black-100'"
            style="background-color: #99b3f0"
          >
            <input
              type="color"
              id="favcolor3"
              class="favcolor"
              name="favcolor"
              value="#99B3F0"
            />
          </div>
          <input
            value="1000"
            type="number"
            id="color3"
            class="colorThreshold w-[60px] border rounded-md text-xs outline-none font-medium appearance-none h-7 px-1.5"
            :class="mode === 'dark' ? 'bg-dark-70 border-dark-50' : ''"
          />
          <div
            id="colorPan4"
            class="w-5 h-5 border-2 border-black-100 rounded-md cursor-pointer"
            style="background-color: #e589ec"
          >
            <input
              type="color"
              id="favcolor4"
              class="favcolor"
              name="favcolor"
              value="#E589EC"
            />
          </div>
        </div>
        <div class="flex items-center text-[15px] gap-2" id="contrast">
          <div class="switcher">
            <input
              type="checkbox"
              id="contrastSwitch"
              @change="contrastClicked"
            />
            <label for="contrastSwitch">Contrast</label>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex items-center justify-between border-b p-4"
      :class="mode === 'dark' ? 'border-dark-50' : ''"
    >
      <p class="font-medium leading-none">
        Total words: {{ totlaWords }} / 1000
      </p>
      <div class="flex items-center gap-2">
        <button class="button primary-button small-button" @click="analyzeFunc">
          <LetterText :size="20" :stroke-width="1.75" />
          Analyze Text
        </button>
        <button
          class="button primary-button small-button"
          @click="originConverter"
        >
          <RemoveFormatting :size="20" :stroke-width="1.75" />
          Remove Formatted Text
        </button>
        <button class="button bg-danger-100 small-button" @click="clear">
          <Eraser :size="20" :stroke-width="1.75" />
          Clear
        </button>
      </div>
    </div>
    <div ref="editorRef" class="results"></div>
    <div id="tooltip"></div>
    <AnalyzeScoreModal
      v-if="isShowScoreModal"
      :show="isAnalyzeScore"
      :score="analyzeScores"
      :mode="mode"
      @click="() => (isAnalyzeScore = false)"
    />
  </div>
</template>

<script>
import { useUserStore } from "../../stores/user";
import { postGLTR, detectAiGenerated } from "../../libs/Api";
import AnalyzeScoreModal from "../common/AnalyzeScoreModal.vue";
import $ from "jquery";
import { LetterText, Eraser, RemoveFormatting } from "lucide-vue-next";

export default {
  setup() {
    const store = useUserStore();
    return {
      store,
    };
  },
  components: {
    AnalyzeScoreModal,
    LetterText,
    Eraser,
    RemoveFormatting,
  },
  props: {
    content: String,
    placeholder: String,
    mode: String,
    isShowScoreModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAnalyzeScore: false,
      analyzeScores: null,
      colors: [
        {
          range: "0-10",
          color: "#7FF581",
        },
        {
          range: "11-100",
          color: "#FCFAB6",
        },
        {
          range: "101-1000",
          color: "#99B3F0",
        },
        {
          range: "1001-10000000",
          color: "#E589EC",
        },
      ],
      invalidTags: ["figure", "ul", "ol", "blockquote", "div"],
      flag: false,
      input: { bpe_strings: [], pred_topk: [], real_topk: [] },
      analyse: true,
      theme: true,
      totlaWords: 0,
    };
  },
  async mounted() {
    $(".token").on("click", () => this.menuFunc());
    $(".colorThreshold").on("change", (event) => this.colorRangeChange(event));
    $("#colorPan1").on("click", () => {
      $("#favcolor1").get(0).click();
    });
    $("#colorPan2").on("click", () => {
      $("#favcolor2").get(0).click();
    });
    $("#colorPan3").on("click", () => {
      $("#favcolor3").get(0).click();
    });
    $("#colorPan4").on("click", () => {
      $("#favcolor4").get(0).click();
    });
    $("#favcolor1").change(() => {
      $("#colorPan1").css("background-color", $("#favcolor1").val());
      this.colors[0].color = $("#favcolor1").val();
      this.parseWords();
    });
    $("#favcolor2").change(() => {
      $("#colorPan2").css("background-color", $("#favcolor2").val());
      this.colors[1].color = $("#favcolor2").val();
      this.parseWords();
    });
    $("#favcolor3").change(() => {
      $("#colorPan3").css("background-color", $("#favcolor3").val());
      this.colors[2].color = $("#favcolor3").val();
      this.parseWords();
    });
    $("#favcolor4").change(() => {
      $("#colorPan4").css("background-color", $("#favcolor4").val());
      this.colors[3].color = $("#favcolor4").val();
      this.parseWords();
    });
    $("#switch").change(() => {
      this.theme = document.getElementById("switch").checked;
      if (!this.analyse) this.parseWords();
    });
    window.addEventListener("click", () => {
      $("#text-prompt").remove();
    });
    window.CKEDITOR.ClassicEditor.create(this.$refs["editorRef"], {
      toolbar: {
        items: [
          "exportPDF",
          "exportWord",
          "|",
          "findAndReplace",
          "selectAll",
          "|",
          "heading",
          "|",
          "bold",
          "italic",
          "strikethrough",
          "underline",
          "code",
          "subscript",
          "superscript",
          "removeFormat",
          "|",
          "bulletedList",
          "numberedList",
          "todoList",
          "|",
          "outdent",
          "indent",
          "|",
          "undo",
          "redo",
        ],
        shouldNotGroupWhenFull: true,
      },
      list: {
        properties: {
          styles: true,
          startIndex: true,
          reversed: true,
        },
      },
      heading: {
        options: [
          {
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph",
          },
          {
            model: "heading1",
            view: "h1",
            title: "Heading 1",
            class: "ck-heading_heading1",
          },
          {
            model: "heading2",
            view: "h2",
            title: "Heading 2",
            class: "ck-heading_heading2",
          },
          {
            model: "heading3",
            view: "h3",
            title: "Heading 3",
            class: "ck-heading_heading3",
          },
          {
            model: "heading4",
            view: "h4",
            title: "Heading 4",
            class: "ck-heading_heading4",
          },
          {
            model: "heading5",
            view: "h5",
            title: "Heading 5",
            class: "ck-heading_heading5",
          },
          {
            model: "heading6",
            view: "h6",
            title: "Heading 6",
            class: "ck-heading_heading6",
          },
        ],
      },
      placeholder: this.placeholder || "Content goes here",
      fontFamily: {
        options: [
          "default",
          "Arial, Helvetica, sans-serif",
          "Courier New, Courier, monospace",
          "Georgia, serif",
          "Lucida Sans Unicode, Lucida Grande, sans-serif",
          "Tahoma, Geneva, sans-serif",
          "Times New Roman, Times, serif",
          "Trebuchet MS, Helvetica, sans-serif",
          "Verdana, Geneva, sans-serif",
        ],
        supportAllValues: true,
      },
      fontSize: {
        options: [10, 12, 14, "default", 18, 20, 22],
        supportAllValues: true,
      },
      htmlSupport: {
        allow: [
          {
            name: /.*/,
            attributes: true,
            classes: true,
            styles: true,
          },
        ],
      },
      htmlEmbed: {
        showPreviews: true,
      },
      link: {
        decorators: {
          addTargetToExternalLinks: true,
          defaultProtocol: "https://",
          toggleDownloadable: {
            mode: "manual",
            label: "Downloadable",
            attributes: {
              download: "file",
            },
          },
        },
      },
      mention: {
        feeds: [
          {
            marker: "@",
            feed: [
              "@apple",
              "@bears",
              "@brownie",
              "@cake",
              "@cake",
              "@candy",
              "@canes",
              "@chocolate",
              "@cookie",
              "@cotton",
              "@cream",
              "@cupcake",
              "@danish",
              "@donut",
              "@dragée",
              "@fruitcake",
              "@gingerbread",
              "@gummi",
              "@ice",
              "@jelly-o",
              "@liquorice",
              "@macaroon",
              "@marzipan",
              "@oat",
              "@pie",
              "@plum",
              "@pudding",
              "@sesame",
              "@snaps",
              "@soufflé",
              "@sugar",
              "@sweet",
              "@topping",
              "@wafer",
            ],
            minimumCharacters: 1,
          },
        ],
      },
      wordCount: {
        onUpdate: (stats) => {
          this.totlaWords = stats.words;
        },
      },
      removePlugins: [
        "CKBox",
        "CKFinder",
        "EasyImage",
        "RealTimeCollaborativeComments",
        "RealTimeCollaborativeTrackChanges",
        "RealTimeCollaborativeRevisionHistory",
        "PresenceList",
        "Comments",
        "TrackChanges",
        "TrackChangesData",
        "RevisionHistory",
        "Pagination",
        "WProofreader",
        "MathType",
      ],
    })
      .then((res) => {
        window.editor = res;
        if (this.content) {
          this.setEditorData(this.content);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    contrastClicked(e) {
      if (e.target.checked) {
        $("#favcolor1").val("#ff0101");
        $("#favcolor1").change();
        $("#favcolor2").val("#fb8218");
        $("#favcolor2").change();
        $("#favcolor3").val("#99caf0");
        $("#favcolor3").change();
        $("#favcolor4").val("#0101ec");
        $("#favcolor4").change();
      } else {
        $("#favcolor1").val("#7FF581");
        $("#favcolor1").change();
        $("#favcolor2").val("#FCFAB6");
        $("#favcolor2").change();
        $("#favcolor3").val("#99B3F0");
        $("#favcolor3").change();
        $("#favcolor4").val("#E589EC");
        $("#favcolor4").change();
      }
    },
    stripHtml(html) {
      const tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    analyzeFunc() {
      this.parseAPI();
      this.analyse = !this.analyse;
    },
    isContain(tag) {
      const index = this.invalidTags.findIndex(
        (item) => item.toUpperCase() == tag.toUpperCase()
      );
      if (index == -1) {
        return false;
      }
      return true;
    },
    setEditorData(data) {
      if (window.editor) {
        window.editor.setData(data);
      }
    },
    getEditorData() {
      const text = this.stripHtml(window.editor.getData());
      return text.replaceAll("⁠", "").replaceAll(" ", " ");
    },
    clear() {
      this.setEditorData("");
      this.store.setGLTRData(null);
    },
    async parseAPI() {
      this.isAnalyzeScore = false;
      try {
        this.input = { bpe_strings: [], pred_topk: [], real_topk: [] };
        this.store.setIsLoading(true);
        const childrens = $(".ck-content").children();
        let text = "";
        const breakpoint = `\r\n`;
        [...childrens].forEach((child, index) => {
          if (!this.isContain($(child).prop("tagName"))) {
            const subText = $(child).prop("innerText");
            if (!subText.trim() == "") {
              if (index !== childrens.length - 1) {
                text += subText + breakpoint;
              } else {
                text += subText;
              }
            }
          }
        });
        text = text.replaceAll("⁠", "").replaceAll(" ", " ");
        if (!text || this.totlaWords <= 0) {
          this.store.setIsLoading(false);
          this.$toast.error("Error: Please Provide content");
          return;
        }
        if (this.totlaWords > 1000) {
          this.store.setIsLoading(false);
          this.$toast.error("Error: Maximum of 1000 words");
          return;
        }
        const { status, data } = await postGLTR(text);
        this.analyzeScores = data.result[0];
        const { status: detectStatus, data: detectionData } =
          await detectAiGenerated(text);
        if (status !== 200) {
          throw new Error("Something went wrong!");
        }
        this.store.setGLTRData(data.result[0]);
        for (const temp of data.result[0].extra_details) {
          this.input.bpe_strings = [
            ...this.input.bpe_strings,
            ...temp.bpe_strings,
          ];
          this.input.pred_topk = [...this.input.pred_topk, ...temp.pred_topk];
          this.input.real_topk = [...this.input.real_topk, ...temp.real_topk];
        }
        if (this.input) {
          this.input.bpe_strings = this.input.bpe_strings.filter(
            (item) => item != "<|endoftext|>"
          );
          this.parseWords();
        }
        if (detectStatus !== 200) {
          throw new Error("Something went wrong while detecting AI!");
        }
        this.store.setAiDetectionResult(detectionData.result);
        this.store.setIsLoading(false);
        this.isAnalyzeScore = true;
      } catch (err) {
        console.error(err);
        this.$toast.error(err.message);
        this.isAnalyzeScore = true;
        this.store.setIsLoading(false);
      }
    },
    originConverter() {
      const childrens = $(".ck-content").children();
      for (let i = 0; i < childrens.length; i++) {
        const child = childrens[i];
        if (this.isContain($(child).prop("tagName"))) continue;
        let subText = $(child).prop("innerText");
        if (subText.trim() == "") continue;
        subText = subText.replaceAll("\n", "<br>");
        let content = `<tag>text</tag>`;
        content = content
          .replace("tag", $(child).prop("tagName"))
          .replace("text", subText);
        $(child).replaceWith(content);
      }
      this.setEditorData($(".ck-content").html());
    },
    parseWords(event) {
      let index = 0;
      const { bpe_strings, real_topk } = this.input;
      try {
        this.flag = true;
        event && event.stopPropagation();
        let output = "";
        const array = [];
        for (const [wordIndex, word] of bpe_strings.entries()) {
          if (word == "<|endoftext|>") {
            continue;
          }
          if (word == "č") {
            index++;
            continue;
          }
          if (
            word == "Ċ " &&
            bpe_strings[wordIndex - 1] &&
            bpe_strings[wordIndex - 1] == "č"
          ) {
            array.push(output);
            output = "";
            index++;
            continue;
          }
          let className = "";
          let color = "";
          let item = `<span class='classname' style='theme: text_color' key='word'>text_view</span>`;
          if (this.theme) {
            item = item.replace("theme", "background-color");
          } else {
            item = item.replace("theme", "color");
          }
          let content = word;
          className += "token";
          if (word.includes("Ġ")) {
            if (word == "Ġ") {
              content = content.replace("Ġ", "&nbsp;");
            } else {
              content = content.replace("Ġ", " ");
            }
          }
          if (
            word == "Ċ " &&
            (!bpe_strings[wordIndex - 1] ||
              (bpe_strings[wordIndex - 1] && bpe_strings[wordIndex - 1] != "č"))
          ) {
            content = content.replace("Ċ ", "<br>");
          }
          item = item
            .replace("classname", className)
            .replace("text_view", content)
            .replace("word", content + "_" + index);
          for (const c of this.colors) {
            const { range, color: text_color } = c;
            const color_range = range.split("-");
            if (
              color_range[0] * 1.0 <= real_topk[index][0] * 1.0 &&
              color_range[1] * 1.0 >= real_topk[index][0] * 1.0
            ) {
              color = text_color;
            }
          }
          index++;
          item = item.replace("text_color", color);
          output += item;
        }
        array.push(output);
        const childrens = $(".ck-content").children();
        let k = 0;
        for (let i = 0; i < childrens.length; i++) {
          const child = childrens[i];
          if (this.isContain($(child).prop("tagName"))) continue;
          const subText = $(child).text();
          if (subText.trim() == "") continue;
          $(child).html(array[k]);
          k++;
        }
        this.setEditorData($(".ck-content").html());
        $(".token").off("click");
        $(".token").on("click", (event) => this.menuFunc(event));
      } catch (err) {
        console.log(err);
      }
    },
    menuFunc(event) {
      const text = $(event.target).attr("key");
      const index = text.split("_")[1] * 1;
      try {
        event.stopPropagation();
        $(".token").removeClass("active");
        $("#text-prompt").remove();
        $(event.target).addClass("active");
        const { pred_topk, real_topk } = this.input;
        const sidebarWidth = $(".sidebar").width();
        const containerWidth = parseInt($("#container").css("margin-left"));
        const container_left = sidebarWidth + containerWidth + 40;
        let output = `<div id='text-prompt' style='position'><div id='prompt_items'>content</div>prompt_score</div>`;
        let prompt_score = `<div id="prompt_score"><div class="text-prompt-score"><span>top_k: topKValue</span><span>prob: probValue</span></div><div class="text-prompt-score"><span>NLP: NLPValue</span><span>Score: ScoreValue</span></div></div>`;
        let result = "";
        const offset = $(event.target).position();
        const top = $(event.target).offset();
        const height = $(event.target).height();
        let position = "left: p_left; top: p_top;";
        position = position
          .replace("p_left", offset.left * 1 + container_left * 1 + 20)
          .replace("p_top", top.top + height + 10);
        output = output.replace("position", position);
        prompt_score = prompt_score
          .replace("topKValue", real_topk[index][0])
          .replace("probValue", real_topk[index][1].toFixed(2))
          .replace("NLPValue", "000")
          .replace("ScoreValue", "000");
        output = output.replace("prompt_score", prompt_score);
        for (const prompt of pred_topk[index]) {
          let content = prompt[0];
          if (content == "Ċ ") continue;
          let item = `<div class='text-prompt-item' key='keyword'><div key='keyword'>content</div><div key='keyword'>score</div></div>`;
          if (content.includes("Ġ")) {
            content = content.replace("Ġ", " ");
          }
          item = item
            .replace("content", content)
            .replace("score", prompt[1].toFixed(2))
            .replaceAll("keyword", prompt[0].replace("Ġ", " ") + "_" + index);
          result += item;
        }
        output = output.replace("content", result);
        $("#tooltip").html(output);
        $("#text-prompt").css({
          left: offset.left * 1 + container_left * 1 + 20,
          top: top.top + height + 10,
          zIndex: 1,
        });
        $(".text-prompt-item").off("click");
        $(".text-prompt-item").on("click", (event) => this.changeToken(event));
      } catch (err) {
        console.log(err);
      }
    },
    changeToken(event) {
      event.stopPropagation();
      const text = $(event.target).attr("key").split("_");
      $(".token.active").text(text[0]);
      this.input.bpe_strings[text[1]] = text[0];
      $(".token.active").removeClass("active");
      $("#text-prompt").remove();
      this.setEditorData($(".ck-content").html());
    },
    colorRangeChange(event) {
      const id = $(event.target).attr("id");
      const color0 = 0;
      const color1 = $("#color1").val();
      const color2 = $("#color2").val();
      const color3 = $("#color3").val();
      switch (id) {
        case "color1":
          this.colors[0].range = `${color0}-${color1}`;
          this.colors[1].range = `${color1 * 1 + 1}-${$("#color2").val()}`;
          break;
        case "color2":
          this.colors[1].range = `${color1}-${color2}`;
          this.colors[2].range = `${color2 * 1 + 1}-${$("#color3").val()}`;
          break;
        case "color3":
          this.colors[2].range = `${color2}-${color3}`;
          this.colors[3].range = `${color3 * 1 + 1}-${10000000}`;
          break;
      }
      if (!this.analyse) {
        this.parseWords();
      }
    },
  },
};
</script>
<style lang="scss">
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 12px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border: 1px solid #e6e7eb;
}
.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e6e7eb;
}
.ck-reset_all :not(.ck-reset_all-excluded *),
.ck.ck-reset_all {
  color: #000;
}
.is-dark .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.is-dark .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  background-color: #272a33;
  border: 1px solid #4c5160;
}
.is-dark .ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.is-dark .ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  background-color: #272a33;
  border: 1px solid #4c5160;
}
.is-dark .ck-reset_all :not(.ck-reset_all-excluded *),
.ck.ck-reset_all {
  color: #fff;
}
.ck.ck-toolbar .ck.ck-toolbar__separator {
  background-color: #e6e7eb;
}
.is-dark .ck.ck-toolbar .ck.ck-toolbar__separator {
  background-color: #4c5160;
}
.ck-editor__editable[role="textbox"] {
  min-height: 400px;
}
.ck-content .image {
  max-width: 80%;
  margin: 20px auto;
}
.result {
  position: relative;
  font-size: 20px;
}
.token {
  font-weight: 500;
  cursor: pointer;
}
.spaceLeft::before {
  content: "";
  margin: 2pt;
}
#prompt_score {
  background-color: #fff;
  width: 200px;
  border-top: 2px solid #888;
}
#prompt_items {
  max-height: 250px;
  width: 200px;
  overflow: auto;
}
#text-prompt {
  position: absolute;
  background-color: #fff;
  box-shadow: 0 2px 6px -1px rgb(0 0 0 / 16%), 0 1px 12px 2px rgb(0 0 0 / 29%);
}
#text-prompt::-webkit-scrollbar {
  width: 10px;
}
#text-prompt::-webkit-scrollbar-track {
  background: #f1f1f1;
}
#text-prompt::-webkit-scrollbar-thumb {
  background: #888;
}
#text-prompt::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.text-prompt-item {
  padding: 2px 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.text-prompt-item:hover {
  background-color: #5e57573b;
}
.text-prompt-score {
  flex-grow: 1;
  padding: 2px 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.text-prompt-score span {
  width: 50%;
}
.favcolor {
  visibility: hidden;
  width: 0;
  height: 0;
}
#theme {
  display: flex;
  column-gap: 10px;
  align-items: center;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 30px;
  margin: 0;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.ck.ck-editor {
  margin: 16px 16px 0;
}
</style>
